import * as Teams from '@microsoft/teams-js';
import * as React from 'react';
import { needsAdobeSignIn } from '../../../../apollo/reactiveVariables/EsignProviderVariables';
import { Paths } from '../../../../common/enums/Paths';
import { ApprovalRequestType } from '../../../../data/types.generated';
import { LogCategory } from '../../../../logger';
import { AuthHelper } from '../../../../utilities/AuthHelper';
import { getAppHost } from '../../../../utilities/TeamsUtils';
import { Spinner } from '../../../components';
import { clearCachedAuthToken } from './utils';

declare const ADOBE_AUTH_URL: string;
const adobeLogoutApi = ADOBE_AUTH_URL + '/public/logout';

export const adobeLogout = (): Promise<void> => {
    const logger = getAppHost().getLogger();
    logger.logTraceInfo(LogCategory.AdobeAuth, 'Calling adobeLogout');
    const adobeLogoutPath = window.location.origin + Paths.BasePath + Paths.AdobeLogout;
    return AuthHelper.getAuthenticationFromTeams(adobeLogoutPath).then((): void => {
        clearCachedAuthToken(ApprovalRequestType.ESign);
        needsAdobeSignIn(true);
    });
};

export const AdobeLogout = (): JSX.Element => {
    const logger = getAppHost().getLogger();
    const loc = getAppHost().getLocale();
    logger.logTraceInfo(LogCategory.AdobeAuth, 'Calling Adobe Logout');

    const onLoad = (): void => {
        // Once the iframe is loaded, we know the cookies have been removed
        Teams.authentication.notifySuccess();
    };

    const style: React.CSSProperties = {
        display: 'none',
    };

    return (
        <>
            <iframe title={loc.strings.log_out} src={adobeLogoutApi} sandbox='' onLoad={onLoad} style={style} />
            <div style={{ height: '100vh' }}>
                <Spinner />
            </div>
        </>
    );
};
